"use client";
import clsx from "clsx";
import Image from "next/image";
import { useRouter } from "next13-progressbar";

export interface HeroSectionProps {
  heroImageUrl?: string;
  heroHeaderText?: string;
  heroSubText?: string;
  heroButtonText?: string;
  textContainerDirection?: string;
  buttonRoute?: any;
  isServiceMerchant: boolean;
  isRestaurantMerchant: boolean;
  merchantColor: string;
}

export const HeroSection = ({
  heroImageUrl = "https://placehold.co/1200x800?text=No+Image",
  heroHeaderText = "Default Header Text",
  heroSubText = "Default Sub Text",
  heroButtonText = "Default Button Text",
  textContainerDirection = "center",
  buttonRoute,
  isServiceMerchant,
  isRestaurantMerchant,
  merchantColor,
}: HeroSectionProps) => {
  const router = useRouter();
  const getOppositeDirection = (direction: string) => {
    switch (direction) {
      case "top":
        return "bottom";
      case "bottom":
        return "top";
      case "left":
        return "right";
      case "right":
        return "left";
      default:
        return direction;
    }
  };

  const oppositeDirection = getOppositeDirection(textContainerDirection);
  const textContainerDirectionClass = clsx({
    "top-1/2": oppositeDirection === "top",
    "bottom-1/2": oppositeDirection === "bottom",
    "left-1/2": oppositeDirection === "left",
    "right-1/2": oppositeDirection === "right",
  });

  const handleButtonClick = () => {
    if (isServiceMerchant) {
      router.push(`/services/all#${buttonRoute}`);
    } else if (isRestaurantMerchant) {
      router.push(`/menu/all#${buttonRoute}`);
    } else {
      router.push(`/${buttonRoute}`);
    }
  };

  return (
    <div
      data-testid="hero-section"
      className="flex flex-col items-center pt-6 sm:px-8"
    >
      <div
        className={[
          "flex",
          "justify-center",
          "items-center",
          "h-[500px]",
          "overflow-hidden",
          "relative",
          "w-full",
          "sm:rounded-lg",
          "w-full",
        ].join(" ")}
      >
        <div
          className={[
            "z-[5]",
            "absolute",
            "rounded-lg",
            "bg-transparent",
            "p-9",
            textContainerDirectionClass,
            "sm:w-[36%]",
            "sm:right-[55%]",
          ].join(" ")}
        >
          <p className={"text-white text-3xl"}>{heroHeaderText}</p>
          <p className={["text-base font-normal text-[#6B7280]"].join(" ")}>
            {heroSubText}
          </p>
          <button
            className={[
              "cursor-pointer",
              "w-full",
              "border-none",
              "mt-5",
              "bg-white",
              "text-[#1F2A37] px-5 py-2.5 gap-2 rounded-lg font-medium text-sm leading-[21px]",
            ].join(" ")}
            onClick={handleButtonClick}
            style={{ color: merchantColor }}
          >
            {heroButtonText}
          </button>
        </div>
        <Image
          className={[
            "absolute",
            "top-0",
            "left-0",
            "w-full",
            "h-full",
            "object-cover",
            "object-center",
          ].join(" ")}
          src={heroImageUrl}
          alt="BackgroundHeroImage"
          width="0"
          height="0"
          sizes="100vw"
          priority
        />
        <div className="absolute inset-0 bg-black opacity-40"></div>
      </div>
    </div>
  );
};
